import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder-back.svg'


const _hoisted_1 = { class: "builder-estimator-summary" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "header-container" }
const _hoisted_4 = { class: "design-title-container" }
const _hoisted_5 = { class: "image-container" }
const _hoisted_6 = {
  key: 0,
  class: "form-container"
}
const _hoisted_7 = { class: "build-price-container" }
const _hoisted_8 = { class: "build-price-amount" }
const _hoisted_9 = { class: "summary-items-container" }
const _hoisted_10 = {
  key: 1,
  class: "design-form-container"
}
const _hoisted_11 = {
  key: 3,
  class: "button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!$setup.canShowSuccessMessage)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button button-prev",
              onClick: $setup.onSelectPrev
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                class: "arrow",
                src: _imports_0
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["BuilderEstimatorStepTitle"], { title: "My Home Design" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode($setup["BuilderEstimatorHouseCustomizeSlider"], { "slider-images": $setup.userSelectionsToSliderImages }, null, 8, ["slider-images"])
      ]),
      (!$setup.isFormOpen && !$setup.canShowSuccessMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "build-price-label" }, "BUILD PRICE:", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString($props.totalPrice), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allSummaryItems, (item) => {
                return (_openBlock(), _createBlock($setup["BuilderEstimatorSummaryItem"], {
                  key: item.id || item.title,
                  title: item.title,
                  value: item.value,
                  price: item.price,
                  imageUrl: item.imageUrl,
                  isMobile: true
                }, null, 8, ["title", "value", "price", "imageUrl"]))
              }), 128))
            ])
          ]))
        : ($setup.isFormOpen && !$setup.canShowSuccessMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode($setup["BuilderEstimatorSummaryDesignForm"], {
                "form-type": $setup.formTypeSelected,
                onSubmit: $setup.onFormSubmit
              }, null, 8, ["form-type"])
            ]))
          : (_openBlock(), _createBlock($setup["BuilderEstimatorSummarySuccessMessage"], {
              key: 2,
              onReset: $setup.resetForm
            })),
      (!$setup.isFormOpen && !$setup.canShowSuccessMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "button button-design",
              onClick: $setup.onGetFreeDesign
            }, "Get your Free Home Design"),
            _createElementVNode("button", {
              class: "button button-consultation",
              onClick: $setup.onBookConsultation
            }, "Book a Free Design Consultation")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}